import { createContext, useEffect, useState, useContext } from "react";
import { fetchWithoutToc } from "./methods";
import { LanguageContext } from "./LanguageContext";
import Loader from "../components/Loader/Loader";
import { apiRoutes } from "./apiRoutes";

export const TranslationsContext = createContext();

export const TranslationsProvider = ({ children }) => {
  const { language } = useContext(LanguageContext);
  const [translations, setTranslations] = useState(null);

  const fetchTranslations = async (lang) => {
    try {
      const response = await fetchWithoutToc(
        `${apiRoutes.translations}?language=${lang}`
      );

      if (!response) {
        console.error("❌ Greška: Nema odgovora od servera");
        window.location.href = "/login";
        return;
      }

      const mappedTranslations = {};
      const data = await response.json();
      data.forEach(({ kljuc, termin }) => {
        mappedTranslations[kljuc] = termin;
      });

      setTranslations(mappedTranslations);
    } catch (err) {
      console.error("❌ Error fetching translations:", err);
      setTranslations({});
    }
  };

  useEffect(() => {
    fetchTranslations(language);
  }, [language]);

  const t = (key) => translations?.[key] || key;

  const refreshTranslations = () => fetchTranslations(language);

  if (!translations) {
    return <Loader />; // Ili custom loader
  }

  return (
    <TranslationsContext.Provider value={{ t, refreshTranslations }}>
      {children}
    </TranslationsContext.Provider>
  );
};
